<div class="flex items-center gap-2">
  <label class="text-sm font-medium text-gray-500 dark:text-gray-400" [for]="id">{{ label }}</label>
  <select class="rounded-lg border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1E2433] focus:ring-primary focus:border-primary text-sm font-medium py-2 pl-3 pr-8" [id]="id" [value]="selectedValue" (change)="onChange($event)">
    <ng-content></ng-content>
  </select>
</div>